// extracted by mini-css-extract-plugin
export default {"container":"NavBar_container__YuZWp","icon":"NavBar_icon__USKFi"};